import { render, staticRenderFns } from "./BienDetailsContactForm.vue?vue&type=template&id=68295638&scoped=true"
import script from "./BienDetailsContactForm.vue?vue&type=script&lang=js"
export * from "./BienDetailsContactForm.vue?vue&type=script&lang=js"
import style0 from "./BienDetailsContactForm.vue?vue&type=style&index=0&id=68295638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68295638",
  null
  
)

export default component.exports